import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { mediaUrl } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { HaveButton, itemImage, OwnedTag } from "./ItemCard";

const Brand = ({ name, logo }) =>
  logo ? (
    <img src={mediaUrl(logo)} alt={name} className="h-8 w-auto max-w-[140px] object-contain" data-testid="item-sheet-brand-logo" />
  ) : (
    <span className="bk-brand-text" data-testid="item-sheet-brand-text">{name}</span>
  );

const Row = ({ k, v }) => (
  <div className="flex justify-between gap-6 border-t border-white/10 py-2 text-sm">
    <dt className="text-[var(--muted)]">{k}</dt>
    <dd className="text-right">{v}</dd>
  </div>
);

export const ItemSheet = ({ item, brands, onClose }) => {
  const logo = item ? brands?.[item.manufacturer] : null;
  const { t } = useLang();
  return (
    <Dialog open={!!item} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-h-[92vh] max-w-3xl overflow-y-auto border-white/10 bg-[#0d0c0a] p-0 text-[#efe8dc]" data-lenis-prevent data-testid="item-sheet">
        {item && (
          <div className="grid md:grid-cols-[1fr_1.1fr]">
            <div className="relative grid min-h-[260px] place-items-center bg-[radial-gradient(circle_at_50%_20%,rgba(123,199,77,0.22),transparent_65%)] p-6">
              <img src={itemImage(item)} alt={item.name} className={`max-h-[340px] w-auto object-contain ${item.image_url ? "" : "opacity-60 grayscale-[30%]"}`} />
              {!item.image_url && <span className="mono absolute bottom-3 text-[10px] text-[var(--muted)]">{t("item.illus")}</span>}
            </div>
            <div className="p-6 md:p-8">
              <Brand name={item.manufacturer} logo={logo} />
              <DialogTitle className="font-display mt-4 text-3xl font-normal leading-tight md:text-4xl" data-testid="item-sheet-title">{item.name}</DialogTitle>
              <div className="mt-3 flex flex-wrap gap-2">
                <span className="bk-chip">{t(`cat.${item.category}`)}</span>
                <span className="bk-chip">{item.decade}s</span>
                <OwnedTag item={item} />
              </div>
              {item.description && <p className="mt-4 text-sm leading-relaxed text-[var(--muted)]">{item.description}</p>}
              <dl className="mt-5">
                <Row k={t("item.maker")} v={item.manufacturer} />
                <Row k={t("item.year")} v={item.year} />
                {item.line && <Row k={t("item.line")} v={item.line} />}
                {item.version && <Row k={t("item.version")} v={item.version} />}
                {(item.specs ?? []).map((s) => <Row key={s.label + s.value} k={s.label} v={s.value} />)}
              </dl>
              <HaveButton item={item} className="btn-primary mt-6" testid="item-sheet-have-it-btn" />
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
